import * as React from "react"
import { IconButton, Tooltip } from "@material-ui/core";
import './LoadTableInfinity.scss'
import { Refresh } from "@material-ui/icons";


export interface ILoadTableInfinityPros {
    last?: boolean | false;
    fetchLoad: (ev: any) => void;
}

const LoadTableInfinity:React.FC<ILoadTableInfinityPros> = (props) => {   
   const {last, fetchLoad } = props;
    return (
        <div className="load-table-box">    
               
          <IconButton color="primary" disabled={last} onClick={fetchLoad}>
            <Tooltip title="Carregar Mais Registros">
               <Refresh/>
            </ Tooltip>
           </IconButton>       
        
        {/* {last && <div className={styles.allDataLoaded}>Todos registros carregados</div>} */}
      </div>
    )
}

export default LoadTableInfinity


// WEBPACK FOOTER //
// ./src/component/load-table/LoadTableInfinity.tsx